import { apiUserLevels } from '~constants/api';
import { get } from '~libs/genericAction';
import { createThunks, Params } from '~libs/reduxUtils';

import { typePrefix as prefix } from '~care-workers/actions';

export const typePrefix = `${prefix}-levels`;

const config = [
  {
    actionType: 'getAll',
    apiPath: apiUserLevels,
    method: get,
    actionParams: { attributes: ['id', 'name'], sort: ['name'], limit: 0 },
  },
  { actionType: 'getOne', apiPath: (params: Params) => `${apiUserLevels}/${params.id}`, method: get },
];

export const { getAll, getOne } = createThunks(typePrefix, config);
